import { Button } from "flowbite-react";
import { AiOutlineLoading } from "react-icons/ai";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import Modal from "./Modal";

const ModalDelete = ({
  handleDelete,
  isOpen,
  setOpenModal,
  title,
  description,
  confirmLabel = "Sim, excluir",
  isLoading,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={() => setOpenModal(false)}
    title="Confirmar exclusão"
    subtitle="Esta ação não pode ser desfeita."
    icon={HiOutlineExclamationCircle}
    size="sm"
    footer={
      <div className="flex justify-end gap-2">
        <Button
          color="light"
          onClick={() => setOpenModal(false)}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          color="failure"
          onClick={handleDelete}
          isProcessing={isLoading}
          processingSpinner={<AiOutlineLoading className="h-5 w-5 animate-spin" />}
          disabled={isLoading}
        >
          {confirmLabel}
        </Button>
      </div>
    }
  >
    <p className="text-sm text-slate-700">{title}</p>
    {description ? (
      <p className="mt-2 text-xs text-slate-500">{description}</p>
    ) : null}
  </Modal>
);

export default ModalDelete;
